import { render } from "./ConfirmLogout.vue?vue&type=template&id=6380f1bd&scoped=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=6380f1bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6380f1bd"]])

export default __exports__